import template from 'text!./ContactDetailsCompany.html';

export default {
    bindings: {contactModel: '<'},
    template
}; 
